module.exports = __webpack_public_path__ + "media/images/event_footer_pc-e0887986d6dc9cb34a04436f6f99273c.png";